import Vue from 'vue';
import Router from 'vue-router';
const _import = require('./_import_' + process.env.NODE_ENV);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

Vue.use(Router);

/* layout */
import Layout from '../views/layout/Layout';

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will no redirct in the levelbar
 * noDropdown : if `noDropdown:true` will has no submenu
 * meta : { role: ['admin'] }  will control the page role
 **/
export const constantRouterMap = [{
  path: '/login',
  name: '登录',
  component: _import('login/index'),
  hidden: true
}, {
  path: '/authredirect',
  name: '',
  component: _import('login/authredirect'),
  hidden: true
}, {
  path: '/404',
  name: '404',
  component: _import('error/404'),
  hidden: true
}, {
  path: '/401',
  name: '401',
  component: _import('error/401'),
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/welcome',
  name: '首页',
  hidden: true,
  children: [{
    path: 'dashboard',
    redirect: '/welcome',
    component: _import('dashboard/index'),
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'welcome',
    component: _import('welcome/index'),
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'shopAuditDetails',
    component: _import('z_auditManage/sonViews/shopAuditDetails'),
    name: '店铺审核详情',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'agentAuditDetails',
    component: _import('z_auditManage/sonViews/agentAuditDetails'),
    name: '代理商审核详情',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'firmAuditDetails',
    component: _import('z_auditManage/sonViews/firmAuditDetails'),
    name: '公司审核详情',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'merAuditDetails',
    component: _import('z_auditManage/sonViews/merAuditDetails'),
    name: '商户审核详情',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'handleAgent',
    component: _import('z_businessManagement/sonViews/agentManage'),
    name: '操作代理商',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'handleMer',
    component: _import('z_businessManagement/sonViews/merDetails'),
    name: '操作商户',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'handleShop',
    component: _import('z_businessManagement/sonViews/shop'),
    name: '操作店铺',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'handleFirm',
    component: _import('z_businessManagement/sonViews/firmDetails'),
    name: '操作公司',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'agentAuditRecord',
    component: _import('z_auditManage/sonViews/agentAuditRecord'),
    name: '代理商审核记录',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'firmAuditRecord',
    component: _import('z_auditManage/sonViews/firmAuditRecord'),
    name: '公司审核记录',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'merAuditRecord',
    component: _import('z_auditManage/sonViews/merAuditRecord'),
    name: '商户审核记录',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'shopAuditRecord',
    component: _import('z_auditManage/sonViews/shopAuditRecord'),
    name: '店铺审核记录',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'ruleSettings',
    component: _import('z_riskControl/ruleSettings/index'),
    name: '规则设置',
  }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'editNotify',
    component: _import('z_businessManagement/sonViews/editNotify'),
    name: '编辑通知',
  }]
},  {
    path: '/',
    component: Layout,
    name: '',
    hidden: true,
    children: [{
      path: 'adDetail',
      component: _import('z_advert/sonViews/adData'),
      name: '广告数据',
    }]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'fundRechargeRecord',
    component: _import('z_merchantWithdrawCash/sonViews/fundRechargeRecord'),
    name: '充值记录',
  },]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'fundRefundRecord',
    component: _import('z_merchantWithdrawCash/sonViews/fundRefundRecord'),
    name: '退款记录',
  },]
}, {
  path: '/',
  component: Layout,
  name: '',
  hidden: true,
  children: [{
    path: 'riskReport',
    component: _import('z_riskControl/riskReport/index'),
    name: '交易报告',
  },]
},
 ]

export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});

export const asyncRouterMap = [{
  path: '',
  component: Layout,
  name: '基础配置管理',
  authority: 'baseManager',
  children: [{
    path: 'user',
    component: _import('admin/user/index'),
    name: '用户管理',
    authority: 'userManager'
  }, {
    path: 'menu',
    component: _import('admin/menu/index'),
    name: '菜单管理',
    authority: 'menuManager'
  }, {
    path: 'group',
    component: _import('admin/group/index'),
    name: '角色权限管理',
    authority: 'groupManager'
  }, {
    path: 'group_type',
    component: _import('admin/groupType/index'),
    name: '角色类型管理',
    authority: 'groupTypeManager'
  }, {
    path: 'gate_log',
    component: _import('admin/gateLog/index'),
    name: '操作日志管理',
    authority: 'gateLogManager'
  }]
}, {
  path: '',
  component: Layout,
  name: '交易管理',
  authority: 'z_tradeManagement',
  children: [{
    path: 'tradingFlow',
    component: _import('z_tradeManagement/tradingFlow/index'),
    name: '交易流水',
    authority: 'tradingFlow'
  },{
    path: 'customs',
    component: _import('z_tradeManagement/customs/index'),
    name: '报关管理',
    authority: 'customs'
  }]
}, {
  path: '',
  component: Layout,
  name: '客户管理',
  authority: 'z_businessManagement',
  children: [{
    path: 'agent',
    component: _import('z_businessManagement/agent/index'),
    name: '代理商',
    authority: 'agent'
  }, {
    path: 'firm',
    icon: 'cash-cny',
    component: _import('z_businessManagement/firm/index'),
    name: '公司',
    authority: 'firm'
  }, {
    path: 'merchant',
    component: _import('z_businessManagement/merchant/index'),
    name: '商户',
    authority: 'merchant',
  }, {
    path: 'opinion',
    icon: 'cash-cny',
    component: _import('z_businessManagement/opinion/index'),
    name: '意见',
    authority: 'opinion'
  }, {
    path: 'notify',
    icon: 'cash-cny',
    component: _import('z_businessManagement/notify/index'),
    name: '通知',
    authority: 'notify',
  }, ]
}, {
  path: '',
  component: Layout,
  name: '审核管理',
  authority: 'z_auditManage',
  children: [{
    path: 'agentAudit',
    component: _import('z_auditManage/agentAudit/index'),
    name: '代理商审核',
    authority: 'agentAudit'
  }, {
    path: 'firmAudit',
    icon: 'cash-cny',
    component: _import('z_auditManage/firmAudit/index'),
    name: '公司审核',
    authority: 'firmAudit',
  }, {
    path: 'merAudit',
    component: _import('z_auditManage/merAudit/index'),
    name: '商户审核',
    authority: 'merAudit'
  }, {
    path: 'shopAudit',
    component: _import('z_auditManage/shopAudit/index'),
    name: '店铺审核',
    authority: 'shopAudit'
  }, {
    path: 'withdrawAudit',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/withdrawAudit/index'),
    name: '兑现审核',
    authority: 'withdrawAudit',
  },{
    path: 'imprestAudit',
    component: _import('z_auditManage/imprestAudit/index'),
    name: '备用金充值审核',
    authority: 'imprestAudit',
  },
  // {
  //   path: 'refundAudit',
  //   component: _import('z_auditManage/refundAudit/index'),
  //   name: '退款审核',
  //   authority: 'refundAudit',
  // },
]
}, {
  path: '',
  component: Layout,
  name: '机构管理',
  authority: 'z_mechanism',
  children: [{
    path: 'mechanism',
    component: _import('z_mechanism/mechanism/index'),
    name: '机构管理',
    authority: 'mechanism'
  }]
}, {
  path: '',
  icon: 'Device',
  component: Layout,
  name: '设备模块',
  authority: 'device_Modular',
  children: [{
    path: 'device',
    icon: 'Device',
    component: _import('z_deviceManagement/index'),
    name: '设备',
    authority: 'deviceManagement'
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: Layout,
  name: '兑现',
  authority: 'withdrawCash',
  children: [{
    path: 'merchantWithdrawCash',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/withdrawal/index'),
    name: '兑现',
    authority: 'merchantWithdrawCash',
  }, {
    path: 'profit',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/profit/index'),
    name: '分润',
    authority: 'profit',
  }, {
    path: 'fund',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/fund/index'),
    name: '资金管理',
    authority: 'fund',
  }, {
    path: 'settlement',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/settlement/index'),
    name: '商户结算',
    authority: 'settlement',
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: Layout,
  name: '人员管理',
  authority: 'personnelManagement',
  children: [{
    path: 'salesmanManagement',
    icon: 'cash-cny',
    component: _import('z_SalesmanManage/index'),
    name: '业务员管理',
    authority: 'salesmanManagement'
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: Layout,
  name: '广告模块',
  authority: 'ad_management',
  children: [{
    path: 'ad',
    icon: 'cash-cny',
    component: _import('z_advert/index'),
    name: '广告',
    authority: 'ad_ad'
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: Layout,
  name: '风控模块',
  authority: 'riskControl_Modular',
  children: [{
    path: 'riskControl',
    icon: 'cash-cny',
    component: _import('z_riskControl/index'),
    name: '风控',
    authority: 'riskControl'
  },{
    path: 'merchantControl',
    component: _import('z_riskControl/merchantControl/index'),
    name: '商戶风控',
    authority: 'merchantControl'
  },{
    path: 'riskMonitoring',
    component: _import('z_riskControl/riskMonitor/index'),
    name: '交易监控',
    authority: 'riskMonitoring'
  },
  {
    path: 'report',
    component: _import('z_riskControl/report/index'),
    name: '交易报告',
    authority: 'report'
  },
]
},
// {
//   path: '',
//   icon: 'cash-cny',
//   component: Layout,
//   name: '测试模块',
//   authority: 'test_Modular',
//   children: [{
//     path: 'test',
//     icon: 'cash-cny',
//     component: _import('z_test/index'),
//     name: '测试',
//     authority: 'test'
//   }]
// },
 ];



// WEBPACK FOOTER //
// ./src/router/index.js